import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './en'
import zhHantTW from './zh-Hant-TW'

// Traditional Chinese (Taiwan) is the default; English is the fallback.
// A ?lang= query param or the profile's locale can switch it at runtime.
const STORAGE_KEY = 'petpro_booking_lang'

function initialLang(): string {
  const fromQuery = new URLSearchParams(window.location.search).get('lang')
  if (fromQuery) return fromQuery
  const stored = window.localStorage.getItem(STORAGE_KEY)
  if (stored) return stored
  return 'zh-Hant-TW'
}

void i18n.use(initReactI18next).init({
  resources: {
    'zh-Hant-TW': zhHantTW,
    en,
  },
  lng: initialLang(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export function setLang(lang: string): void {
  window.localStorage.setItem(STORAGE_KEY, lang)
  void i18n.changeLanguage(lang)
  document.documentElement.lang = lang.startsWith('zh') ? 'zh-Hant' : 'en'
}

export default i18n
